import { Fragment } from 'react';
import { Skeleton } from '@savvy-kit/components/skeleton';
import { TableBody } from '@savvy-kit/components/table';

type ClientsTableSkeletonProps = {
  readonly columnCount?: number;
};

export function ClientsTableSkeleton({ columnCount = 5 }: ClientsTableSkeletonProps) {
  const rowKeys = ['skeleton-row-1', 'skeleton-row-2', 'skeleton-row-3'];

  return (
    <TableBody>
      {rowKeys.map((rowKey) => (
        <Fragment key={rowKey}>
          <SkeletonRow columnCount={columnCount} />
        </Fragment>
      ))}
    </TableBody>
  );
}

type SkeletonRowProps = {
  readonly columnCount: number;
};

function SkeletonRow({ columnCount }: SkeletonRowProps) {
  return (
    <tr>
      <td colSpan={columnCount + 1}>
        <div className="flex flex-row px-6 py-5 gap-4 border-b border-b-border-light">
          <Skeleton className="h-5 rounded-none" style={{ flex: 2 }} />

          {Array.from({ length: columnCount - 1 }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Skeleton key={`col-${index}`} className="h-5 flex-1 rounded-none" />
          ))}

          <Skeleton className="h-8 w-8 rounded-full" />
        </div>
      </td>
    </tr>
  );
}

export function ClientsTableSkeletonFooter() {
  return (
    <div className="flex flex-row items-center justify-end px-6 py-2 border-t border-t-border-light">
      <Skeleton className="h-[30px] w-[300px] rounded-none" />
    </div>
  );
}
